import React, { useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

import { useConnectStore } from '../../../../../../store/models';
import UpgradePlanDialog from '.';
import useConfirmationDialogV2 from '../../../../../../commons/dialogV2/useConfirmationDialogV2';

function useUpgradePlanDialog (props = {}) {
    const { open: defaultOpen = false } = props;
    const connectStore = useConnectStore();
    const theme = useTheme();

    const [open, setOpen] = useState(defaultOpen);

    // Re-fetches the current plan once the publisher dismisses the success
    // dialog, so the billing card reloads with the newly-scheduled plan even
    // if the earlier onSubscribed refresh raced the backend's own processing.
    const { openDialog: openSuccessDialog, renderDialog: renderSuccessDialog } = useConfirmationDialogV2({
        showPrimaryButton: true,
        showSecondaryButton: false,
        confirmLabel: 'Ok',
        onConfirm: () => connectStore.getCurrentPlan(),
    });

    // A pending plan change/cancellation blocks any further change until it
    // resolves — reload rather than refetch, so the whole page (not just the
    // plan card) reflects the now-stale state that caused the conflict.
    const { openDialog: openScheduleConflictDialog, renderDialog: renderScheduleConflictDialog } = useConfirmationDialogV2({
        icon: ErrorOutlineOutlinedIcon,
        accentColor: theme.palette.error.main,
        confirmButtonColor: theme.palette.error.main,
        showPrimaryButton: true,
        showSecondaryButton: false,
        confirmLabel: 'Ok',
        onConfirm: () => window.location.reload(),
    });

    function renderUpgradePlanDialog () {
        return (
            <React.Fragment>
                {open && (
                    <UpgradePlanDialog
                        open={open}
                        onClose={() => {
                            setOpen(false);
                        }}
                        onPaymentSuccess={openSuccessDialog}
                        onScheduleConflict={openScheduleConflictDialog}
                    />
                )}
                {renderSuccessDialog()}
                {renderScheduleConflictDialog()}
            </React.Fragment>
        );
    }

    function openDialog () {
        setOpen(true);
    }

    return {
        renderUpgradePlanDialog,
        openDialog,
    };
}

export default useUpgradePlanDialog;
